<div>
  <markant-platform-ui-page-header class="header">
    {{ headline | transloco }} ({{ totalCount }})

    @if (organization) {
      <div actions>
        @if (
          !organization.ezrCustomer &&
          isQualificationLevel3 &&
          isOrganizationAdmin
        ) {
          <markant-button
            colorScheme="secondary"
            variant="clear"
            class="button-link"
            data-cy="my-price-requests"
            [routerLink]="['price-requests', 'organization-administrator']"
          >
            <span>{{
              'organization.profile.navigation.priceEnquiries' | transloco
            }}</span>

            <markant-icon
              icon="m_arrow-right"
              slot="icon-trailing"
            ></markant-icon>
          </markant-button>
        }

        @if (organization.ezrCustomer && isPlatformAdmin) {
          <markant-button
            data-cy="button-open-cartridge-dialog"
            class="button-add-cartridges"
            colorScheme="primary"
            variant="clear"
            (click)="openCartridgesDialog()"
            (keydown.enter)="openCartridgesDialog()"
          >
            <markant-icon
              slot="icon-leading"
              icon="m_plus-small"
            ></markant-icon>
            {{ 'usageRight.addCartridgesButton' | transloco }}
          </markant-button>
        }
      </div>
    }
  </markant-platform-ui-page-header>

  @if (tableDraft) {
    <markant-platform-organization-bookings-table
      [draft]="tableDraft"
      [forceUpdate]="forceUpdate"
      [loadFunction]="getBookingsForOrganization"
      [filter]="filter"
      (updateFilterValues)="onUpdateFilterValues()"
    >
    </markant-platform-organization-bookings-table>
  }
</div>

@if (
  organization &&
  organization.ezrCustomer &&
  isPlatformAdmin &&
  isCartridgesDialogOpen
) {
  <markant-platform-modal-bridge>
    <markant-platform-organization-add-cartridges-dialog
      [organization]="organization"
      [isDialogOpen]="true"
      (closeDialog)="closeCartridgesDialog()"
      (organizationUpdated)="updateOrganizationData($event)"
    >
    </markant-platform-organization-add-cartridges-dialog>
  </markant-platform-modal-bridge>
}
